import * as React from "react";
import { IdStyles } from "../../../less/IdStyles";
import { IdLoca } from "../../../utils/i18n/IdLoca";
import { ButtonPrimary } from "../../generic/common/ButtonPrimary";
import { Icon } from "../../generic/icon/Icon";
import { IdIcon } from "../../generic/icon/IdIcon";
import { NumberFormat } from "../../generic/number-format/NumberFormat";
import { TextLoca } from "../../generic/text/TextLoca";
import { ButtonGoto } from "../../tournament-building/ButtonGoto";
export var CoopHelpInfo = function (_a) {
    var loyaltyPoints = _a.loyaltyPoints, onGoToShopClick = _a.onGoToShopClick;
    return (React.createElement("div", { className: IdStyles.CoopHelpInfoContainer + " " + IdStyles.TextNormal + " flex flex--stacked flex--spaced flex--guts" },
        React.createElement("div", { className: IdStyles.CoopHelpPointsContainer + " flex flex--aligned" },
            React.createElement(Icon, { styleId: IdStyles.IconMedium, icon: IdIcon.LoyaltyPointsIcn }),
            React.createElement("div", { className: "loyalty-points" },
                React.createElement(NumberFormat, { className: IdStyles.TextBoldSecondaryOutline, amount: loyaltyPoints }))),
        React.createElement(TextLoca, { className: IdStyles.TextNormal + " coop-help-description", id: IdLoca.coopHelp_desc }),
        React.createElement("div", { className: "coop-help-deco-img" }),
        React.createElement("div", { className: "goToBtn__container" },
            React.createElement(ButtonGoto, { onClick: onGoToShopClick, buttonType: ButtonPrimary, destinationIcon: IdIcon.ShopIcn }))));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/cooperative/help/CoopHelpInfo.tsx
// module id = 2602
// module chunks = 3